import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import media from 'client/styles/media';

import PaddingContainer from './PaddingContainer';
import LinkButton from './LinkButton';

const PersonalizedSection = styled.section`
  position: relative;
  width: 100%;
  padding: 70px 0 100px;
  background: #fbf4ef;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -5px;
    right: 0;
    height: 20px;
    background: url('https://static.introwise.com/images/elements/main/intersect_orange.svg') top left repeat-x;
    z-index: 10;
  }

  ${media.sm} {
    margin-top: 100px;
  }

  ${media.md} {
    margin-top: 0;
  }

  ${media.lg} {
  }
`;

const ParticipantsBlock = styled.div`
  margin-bottom: 80px;
  h2 {
    ${({ theme }) => theme.typography.h1};
    margin: 0 0 32px;
  }
  .img-content {
    display: block;
    max-width: 100%;
    box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.1);
    border-radius: 16px;
    margin-bottom: 26px;
  }
  h3 {
    ${({ theme }) => theme.typography.h2};
    margin: 0 0 0.75em;
  }

  h4 {
    margin: 8px 0;
  }
  p {
    margin: 8px 0;
  }

  ${media.sm} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 16px;

    h2 {
      grid-column: 1 / span 12;
    }
    .img-content {
      grid-column: 1 / span 5;
    }
    .text {
      grid-column: 7 / span 6;
    }
  }
  ${media.md} {
    h2 {
      ${({ theme }) => theme.typography.hero};
    }
    h3 {
      ${({ theme }) => theme.typography.h1};
      font-size: 36px;
      line-height: 140%;
      margin: -10px 0 0.75em;
    }
  }
  ${media.lg} {
    h2 {
      grid-column: 2 / span 11;
    }
    .img-content {
      grid-column: 2 / span 7;
      max-width: 600px;
    }
    .text {
      grid-column: 9 / span 3;
    }
  }
`;

const ParticipantPro = styled.div`
  position: relative;
  margin-top: 26px;
  img {
    position: absolute;
    left: -42px;
    top: -4px;
  }
`;

const BlocksWrap = styled.div`
  position: relative;
  z-index: 0;
  ${media.md} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 16px;
    &:before {
      content: '';
      display: block;
      width: 214px;
      height: 42px;
      background: url(https://static.introwise.com/images/elements/main/colored_arrows.svg) no-repeat;
      position: absolute;
      z-index: -1;
      left: 50%;
      margin-left: -147px;
      top: -20px;
    }
  }
  ${media.lg} {
  }
`;

const EventBlock = styled.div`
  margin-bottom: 80px;
  ${media.sm} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px;
    margin-bottom: 40px;
  }
  ${media.md} {
    grid-column: 1 / span 7;
  }
  ${media.lg} {
    grid-column: 2 / span 6;
  }
`;

const EventHeader = styled.div`
  position: relative;
  h3 {
    ${({ theme }) => theme.typography.h1};
    margin: 0 0 16px;
    & + p {
      ${({ theme }) => theme.typography.h4};
      margin: 0;
    }
  }
  ${media.sm} {
    grid-column: span 2;
  }
  .icon {
    position: absolute;
    right: -15px;
    top: 0;
  }
  ${media.sm} {
    .icon {
      left: -56px;
    }
  }
`;
const EventPartOrg = styled.div`
  margin: 40px 0;
  max-width: 320px;
  h4 {
    ${({ theme }) => theme.typography.h3};
    margin-top: 0;
  }
  ul {
    list-style-type: none;
    margin: 0 0 36px;
    padding: 0;
    li {
      margin-bottom: 20px;
      padding-left: 72px;
      position: relative;
    }
    img {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  ${media.md} {
    margin: 40px 0 60px;
    &.event-par {
      li {
        padding-right: 10px;
      }
    }
    &.event-org {
      margin-right: -45px;
    }
  }
`;

const EventSp = styled.div`
  margin-bottom: 40px;
  h4 {
    ${({ theme }) => theme.typography.h3};
    margin-top: 0;
  }

  ${media.md} {
    &.event-speakers {
      margin-right: -45px;
    }
  }
`;

const EventSpLinks = styled.div`
  a {
    font-weight: bold;
    color: ${({ theme }) => theme.color.blue};
    :hover,
    :focus {
      opacity: ${({ theme }) => theme.button.opacity.hover};
      text-decoration: none;
    }
  }
`;

const CommunityBlock = styled.div`
  margin-bottom: 80px;
  position: relative;
  z-index: 0;
  .icon {
    position: absolute;
    right: -15px;
    top: 0;
  }
  h3 {
    ${({ theme }) => theme.typography.h1};
    margin: 0;
  }
  h4 {
    ${({ theme }) => theme.typography.h2};
    font-family: 'Nunito Sans', Arial, sans-serif;
    margin: 1.5em 0 0.5em;
  }
  p {
    margin: 0 0 0.75em;
  }
  .img-bg {
    position: absolute;
    left: -130px;
    top: 50%;
    transform: translateY(-40%);
    z-index: -1;
  }
  ${media.md} {
    grid-column: 9 / span 4;
    h3 {
      margin-bottom: 60px;
    }
    .img-bg {
      transform: translateY(-55%);
    }
    .icon {
      left: -56px;
    }
  }
  ${media.lg} {
    grid-column: 9 / span 3;
  }
`;

const Personalized = () => (
  <PersonalizedSection id="personalized">
    <PaddingContainer>
      <ParticipantsBlock>
        <h2>Personalized</h2>
        <img
          className="img-content"
          src="https://static.introwise.com/images/elements/main/personalized_foto.jpg"
          alt=""
        />
        <div className="text">
          <h3>
            The first app made for <span className="pink-highlight">participants</span>
          </h3>
          <ParticipantPro>
            <img src="https://static.introwise.com/images/elements/main/dot_red.svg" alt="" />
            <h4>Where size is flexible</h4>
            <p>
              Small to big events from co-working meetups and summer camps to tech conferences and accelerator demos.
            </p>
          </ParticipantPro>
          <ParticipantPro>
            <img src="https://static.introwise.com/images/elements/main/dot_blue.svg" alt="" />
            <h4>Where support is given</h4>
            <p>Building a community of people sharing their passions and offering help first.</p>
          </ParticipantPro>
          <ParticipantPro>
            <img src="https://static.introwise.com/images/elements/main/dot_yellow.svg" alt="" />
            <h4>Where interests matter</h4>
            <p>
              Start your own group chat and trust our magic algorithms to match you with people who are more likely to
              join discussion.
            </p>
          </ParticipantPro>
        </div>
      </ParticipantsBlock>

      <BlocksWrap>
        <EventBlock>
          <EventHeader>
            <img className="icon" src="https://static.introwise.com/images/elements/main/red_flake.svg" alt="" />
            <h3>Event</h3>
            <p>Benefits before, during and after</p>
          </EventHeader>
          <EventPartOrg className="event-par">
            <h4>Participants</h4>
            <ul>
              <li>
                <img src="https://static.introwise.com/images/elements/main/icon_ice.svg?v=2" alt="" />
                <p>Break the ice and find people of similar interests</p>
              </li>
              <li>
                <img src="https://static.introwise.com/images/elements/main/icon_settings.svg" alt="" />
                <p>Personalize the event the way you want it</p>
              </li>
              <li>
                <img src="https://static.introwise.com/images/elements/main/icon_dialog.svg" alt="" />
                <p>Keep in touch with people you{"'"}ve met</p>
              </li>
            </ul>
          </EventPartOrg>
          <EventPartOrg className="event-org">
            <h4>Organizers</h4>
            <ul>
              <li>
                <img src="https://static.introwise.com/images/elements/main/icon_person.svg" alt="" />
                <p>Prepare the event based on people{"'"}s actual needs</p>
              </li>
              <li>
                <img src="https://static.introwise.com/images/elements/main/icon_house.svg" alt="" />
                <p>Run event day communications from a single place</p>
              </li>
              <li>
                <img src="https://static.introwise.com/images/elements/main/icon_analytics.svg" alt="" />
                <p>Understand participants{"'"} engagement and act accordingly</p>
              </li>
            </ul>
            <LinkButton variant="pink" to="/organize">
              Create Event
            </LinkButton>
          </EventPartOrg>
          <EventSp className="event-sponsors">
            <h4>Sponsors</h4>
            <p>
              Get more visibility through showcasing your products and services before the event. Hire faster. Increase
              your ROI.
            </p>
            <EventSpLinks>
              <Link to="/event-sponsors">For Sponsors</Link> | <Link to="/contact">Contact us</Link>
            </EventSpLinks>
          </EventSp>
          <EventSp className="event-speakers">
            <h4>Speakers</h4>
            <p>
              Get to know the audience and their interests and respond to their burning questions, during which you can
              grow your network and reach it anyplace and anytime.
            </p>
            <EventSpLinks>
              <Link to="/contact">Contact us</Link>
            </EventSpLinks>
          </EventSp>
        </EventBlock>
        <CommunityBlock>
          <h3>Community</h3>
          <img className="icon" src="https://static.introwise.com/images/elements/main/blue_zigzag.svg" alt="" />
          <h4>Members</h4>
          <p>
            Find like-minded people, get advice or help others. Add meetups to community-driven calendar for more
            face-to-face connections.
          </p>
          <h4>Leaders</h4>
          <p>
            Keep you community engaged and organized, even for thousands of members, thanks to our recommendation
            algorithms.
          </p>
          <LinkButton style={{ marginTop: 36 }} variant="blueLight" to="/organize">
            Create Community
          </LinkButton>
          <img className="img-bg" src="https://static.introwise.com/images/elements/main/community_bg.svg" alt="" />
        </CommunityBlock>
      </BlocksWrap>
    </PaddingContainer>
  </PersonalizedSection>
);

export default Personalized;
